import { withPublicHOC } from '../../hoc';
import {
  PublicContentContainer,
  PublicPageHeading,
  PublicPageContent,
} from '../../components/styled';

const PublicPage = ({ refundPolicy }) => {
  return (
    <PublicContentContainer>
      <PublicPageHeading>
        <h1>Refund Policy</h1>
      </PublicPageHeading>
      <PublicPageContent
        className="content"
        dangerouslySetInnerHTML={{ __html: refundPolicy }}
      ></PublicPageContent>
    </PublicContentContainer>
  );
};

export default withPublicHOC(PublicPage);
